import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { IChecklist, IResponse } from "@signal/asp-data-commons";
import { Observable, of } from "rxjs";
import { mergeMap, map, catchError, switchMap } from "rxjs/operators";
import { AlertService } from "../../shared/services/alert.service";
import { ChecklistService } from "../../shared/services/checklist.service";
import { toData } from "../app.adapter";
import * as fromActions from './checklist.actions';

@Injectable()
export class ChecklistEffects {
  somethingWentWrongPleaseReloadThePage = 'otherTexts.somethingWentWrongPleaseReloadThePage';

  
  loadAllChecklist: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<fromActions.LoadAllChecklist>(
      fromActions.ChecklistActionTypes.LOAD_ALL_CHECKLIST
    ),
    mergeMap((action: fromActions.LoadAllChecklist) =>
      this.checklistService.getAllChecklist().pipe(
        map((checklistDetails: IChecklist[]) => new fromActions.LoadAllChecklistSuccess({ checklistDetails })),
        catchError(err => {
          this.alertService.showAlert(this.somethingWentWrongPleaseReloadThePage);
          return of(new fromActions.LoadAllChecklistFailure({ error: err }))
        })
      )
    )
  ));

  
  updateChecklist: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<fromActions.UpdateChecklist>(
      fromActions.ChecklistActionTypes.UPDATE_CHECKLIST
    ),
    mergeMap((action: fromActions.UpdateChecklist) => {
      return this.checklistService.updateChecklist(action.payload.checklist).pipe(
        switchMap((updateChecklist: IResponse<IChecklist>) => toData(updateChecklist)),
        map(
          (updateChecklist: IChecklist) => {
            this.alertService.showAlert('otherTexts.detailsUpdatedSuccessfully', `${updateChecklist.displayName}`, '', 5000, false);
            return new fromActions.UpdateChecklistSuccess({ checklist: updateChecklist })
          },
        ),
        catchError(err => {
          this.alertService.showAlert(err?.error?.status?.messages[0] || this.somethingWentWrongPleaseReloadThePage);
          return of(new fromActions.UpdateChecklistFailure({ error: err }))
        })
      )
    }
    )
  ));

  constructor(
    private readonly actions$: Actions,
    private readonly checklistService: ChecklistService,
    private readonly alertService: AlertService
  ) {
  }

}